// extracted by mini-css-extract-plugin
module.exports = {"root":"MinimalLoader__root--1zYBL","fade-in":"MinimalLoader__fade-in--3domc"};